import $http from "@/utils/request.js";
import qs from "qs";

export function getConfigApi(data) {
    return $http.post('/getJsConfig', qs.stringify(data))
}

export function getConfigNoLoginApi(data) {
    return $http.post('/getJsConfigNoLogin', qs.stringify(data))
}